import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';

import { usePrepaymentDetailContext } from 'contexts/PrepaymentDetailContext';
import PrepaymentShipmentList from '../PrepaymentComponents/PrepaymentShipmentList';
import PrepaymentTransactionHistory from '../PrepaymentComponents/PrepaymentTransactionHistory';
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "screens/App/CRM/Document/DocumentTab";
import { useAuth } from "hooks";

const PrepaymentDetailTab = () => {
  const [searchParams] = useSearchParams();
  const {isVendor} = useAuth();
  const activeTab = searchParams.get('tab') || 'transactions';
  const { prepaymentDetail } = usePrepaymentDetailContext();

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'DeliveryCollection', sourceRef: prepaymentDetail?._id, }, { skip: !prepaymentDetail?._id }
  );

  const tabs = [
    {
      label: 'Apply Prepayment',
      value: 'shipment',
      badgeCount: prepaymentDetail?.shipment?.length || 0,
    },
    {
      label: 'Transaction History',
      value: 'transactions',
      badgeCount: 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },

  ].filter(tab => tab.value !== 'shipment' || (prepaymentDetail?.balanceAmount !== 0 && !isVendor));

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />
      {prepaymentDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value='transactions'>
            <PrepaymentTransactionHistory />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="DeliveryCollection" sourceRef={prepaymentDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value='shipment'>
            <PrepaymentShipmentList />
          </CustomTabPanel>


        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default PrepaymentDetailTab;